"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _excluded = ["body", "footer", "minHeight"];

var _this = void 0;

/**
 * ChargeInfo.ModalWrapper
 * @description 计费UI组件-弹窗内基本布局
 */
var ModalWrapper = function ModalWrapper(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var body = _ref.body,
      footer = _ref.footer,
      minHeight = _ref.minHeight,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_style.StyledModalWrappper, (0, _extends2["default"])({
    minHeight: minHeight
  }, others), body, footer && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style.prefixCls, "-modal-wrapper-footer")
  }, footer));
}.bind(void 0);

ModalWrapper.propTypes = {
  /**
   * 上部主内容区域的内容
   */
  body: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * 下部价格区域的内容
   */
  footer: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * 设定容器的最小高度
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
ModalWrapper.defaultProps = {
  minHeight: 296
};
var _default = ModalWrapper;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/ModalWrapper.js
// module id = 2081
// module chunks = 6 7 17 18